var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"pt-3 pb-5",attrs:{"id":"listings-seo-content-block"}},[_c('b-row',[_c('b-col',[_c('b-row',[(_vm.richContent)?_c('b-col',{staticClass:"mt-4"},[_c('RichTextRenderer',{attrs:{"document":_vm.richContent}})],1):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }